<div
  fxLayout="{{ (breakpointSecondColumn | async) ? 'column' : 'row' }}"
  [fxLayoutAlign]="rowFxLayoutAlign"
  [fxLayoutGap]="fxLayoutGap"
>
  <div
    fxFlex="{{
      (breakpointThirdColumn | async)
        ? (breakpointSecondColumn | async)
          ? '100%'
          : '50%'
        : column1FxFlex
    }}"
    fxLayout="{{ (breakpointSecondColumn | async) ? 'row' : 'column' }}"
    fxFlexFill
    [fxLayoutAlign]="column1FxLayoutAlign"
    fxFlexOrder="{{
      revertOrderOnBreakpoint && (breakpointSecondColumn | async) ? '1' : '0'
    }}"
  >
    <ng-content select="[col-1]"></ng-content>
  </div>

  <div
    fxFlex="{{
      (breakpointThirdColumn | async)
        ? (breakpointSecondColumn | async)
          ? '100%'
          : '50%'
        : column2FxFlex
    }}"
    fxLayout="{{ (breakpointSecondColumn | async) ? 'row' : 'column' }}"
    fxFlexFill
    [fxLayoutAlign]="column2FxLayoutAlign"
  >
    <ng-content select="[col-2]"></ng-content>
  </div>

  <div
    *ngIf="!(breakpointThirdColumn | async)"
    fxFlex="{{ column3FxFlex }}"
    fxLayout="column"
    [fxLayoutAlign]="column3FxLayoutAlign"
  >
    <ng-container *ngTemplateOutlet="thirdColumnOutlet"></ng-container>
  </div>
</div>

<div
  *ngIf="breakpointThirdColumn | async"
  fxLayout="row"
  fxFlexFill
  [fxLayoutAlign]="column3FxLayoutAlign"
>
  <ng-container *ngTemplateOutlet="thirdColumnOutlet"></ng-container>
</div>

<ng-template #thirdColumnOutlet>
  <ng-content select="[col-3]"></ng-content>
</ng-template>
